import { Card, Chip, Link, Tab, Table, Typography } from '@mui/joy'
import React from 'react'

function AltTarifTable({data, tablename, kathid}) {
  return (
    <>
    <Card variant='soft' sx={{mt: 3}}>
      <Typography level="title-md">{tablename}</Typography>
      <Table sx={{ '& thead th:nth-child(1)': { width: "45%" } }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Information</th>
                    <th>Art</th>
                  </tr>
                </thead>
                <tbody>
                {
                  [...data] // Kopie, um Original nicht zu verändern
                    .sort((a, b) => b.name.localeCompare(a.name)) // Absteigend
                    .map((item) => (
                      <tr key={item.id}>
                        <td><Link href={"/tarif/" + item.id + "/" + kathid}>{item.name}</Link></td>
                        <td>
                          {item.emty && (
                            <Chip color="danger">
                              Leerer Tarif
                            </Chip>
                          )}
                          {
                            item.alttarif && (
                              <>
                              <Chip color="success">{item.gesellschaft}</Chip>
                              <Chip color='sucsess'>AltTarif</Chip>
                            
                              </>
                            )
                          }
                        </td>
                        <td>
                            {
                                item.type
                            }
                        </td>
                      </tr>
                    ))
                }


                </tbody>
      </Table>
    </Card>

    </>
  )
}

export default AltTarifTable
